module.exports = {
  en: {
    message: {
      welcome: 'Welcome',
      settings: 'Settings',
      seats: 'Umbrellas in total',
      beach: 'Beach',
      pool: 'Pool',
      umbrella: {
        free: '',
        occupied: ''
      }
    }
  },
  it: {
    message: {
      welcome: 'Benvenuto',
      settings: 'Impostazioni',
      seats: 'Ombrelloni in totale',
      beach: 'Spiaggia',
      pool: 'Piscina',
      umbrella: {
        free: 'liberi',
        occupied: 'occupati'
      }
    }
  },
  de: {
    message: {
      welcome: 'Willkommen',
      settings: 'Einstellungen',
      seats: 'Schirme',
      beach: 'Strand',
      pool: 'Pool',
      umbrella: {
        free: '',
        occupied: ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale.js